class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  formatPrice(num) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',

      // These options are needed to round to whole numbers if that's what you want.
      //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    // Shopify gives us whole numebrs that include cents, hence /100
    return formatter.format(num / 100);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updateVariantPrice();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
    const newId = newMedia.dataset.mediaId;
    const newThumb = document.querySelector(`[data-thumb-id="${newId}"]`);
    const thumbLocate = newThumb['offsetLeft'];

    document
      .querySelectorAll('.slide-image')
      .forEach((thumb) => thumb.classList.remove('active-thumb'));
    document
      .querySelector(`[data-thumb-id="${newId}"] > img`)
      .classList.add('active-thumb');
    const sliderBox = document.querySelector('.product-slider-box');
    sliderBox.scrollTo({ left: thumbLocate });
    //zoom();
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantPrice() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const quantityInput = document.querySelector('quantity-input');
      let quantity = quantityInput.querySelector('input').value;
      const price = productForm.querySelector('.price__regular .price-item');
      const regularPrice = productForm.querySelector(
        '.price__sale .price-item--regular'
      );

      const salePrice = productForm.querySelector(
        '.price__sale .price-item--sale'
      );

      price.innerHTML = this.formatPrice(this.currentVariant.price * quantity);
      regularPrice.innerHTML = this.formatPrice(
        this.currentVariant.compare_at_price * quantity
      );
      salePrice.innerHTML = this.formatPrice(
        this.currentVariant.price * quantity
      );
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButtons = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelectorAll('[name="add"]');
    const addButtonStatus = document.querySelector(
      '[name="add"] .product-form__submit-status'
    );
    const addButtonPrice = document.querySelector(
      '[name="add"] .product-form__submit-price'
    );
    if (!addButtons) return;
    if (disable) {
      addButtons.forEach((addButton) =>
        addButton.setAttribute('disabled', true)
      );
      if (text) addButtonStatus.textContent = text;
      //addButtonPrice.classList.add('hidden');
    } else {
      addButtons.forEach((addButton) => addButton.removeAttribute('disabled'));
      //addButtonPrice.classList.remove('hidden');
      addButtonStatus.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButtons = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelectorAll('[name="add"]');
    const addButtonStatus = document.querySelector(
      '[name="add"] .product-form__submit-status'
    );

    if (!addButtons) return;
    addButtonStatus.textContent = window.variantStrings.unavailable;
    // addButtons.forEach((addButton) =>  .log(addButton));

    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
